export default __webpack_public_path__ + "static/media/sbi-icon.c084d035.svg";